<div *ngIf="loader" id="spinerLoader" class="container">
    <ds-loading-spinner [diameter]="100" [strokeWidth]="11" color="#b52323"></ds-loading-spinner>
</div>

<div mat-dialog-title class="modal-header header-radius-4 py-0">
    <div class="mx-3 d-flex justify-content-between align-items-center">
        <div>
            <h4 class="d-inline-block">Role Assignment</h4>
            <span *ngIf="spinnerLoader">
                <ds-loading-spinner class="text-color-white ml-2" theme="inherit" [diameter]="14" [strokeWidth]="2"></ds-loading-spinner>
            </span>
        </div>
        <div>
            <button mat-dialog-close class="close close-btn" type="button">
                <ds-icon name="close" size="inherit"></ds-icon>
            </button>
        </div>
    </div>
</div>
<form id="addCustomer" #assignForm="ngForm" name="assignForm">
    <div class="modal-body">
        <div class="row">
            <div class="form-group col-lg-12">
                <label>Select Role</label>
                <div>
                    <br />
                    <div class="multirole-container text-bold float-right">Default Role</div>
                    <br />
                    <ng-container *ngFor="let role of roleList; let i = index">
                        <div id="role{{ i }}" class="multirole">
                            <input
                                id="multiple-role-{{ role.rolename }}"
                                name="selectedMultipleRole"
                                type="checkbox"
                                [checked]="
                                    assignedDefaultRole == role.roleid ||
                                    assignedMultipleRoles.has(role.roleid) ||
                                    (user.memberId == editRoleAssignmentPayload.memberDetail.memberId && user.role == role.rolename)
                                "
                                [disabled]="
                                    assignedDefaultRole == role.roleid ||
                                    disableAdminRoleSelectionForInvalidEmail(role) ||
                                    (user.memberId == editRoleAssignmentPayload.memberDetail.memberId && user.role == role.rolename)
                                "
                                [value]="role.roleid"
                                (change)="selectMultipleRole($event)"
                            />
                            {{ role.rolename }}
                            <input
                                id="default-role-{{ role.rolename }}"
                                class="float-right"
                                name="defaultRole"
                                type="radio"
                                [checked]="assignedDefaultRole == role.roleid"
                                [ngClass]="disableAdminRoleSelectionForInvalidEmail(role) ? 'disable-radio' : ''"
                                [value]="role.roleid"
                                [(ngModel)]="assignedDefaultRole"
                            />
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button mat-dialog-close class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10">Cancel</button>
        <button class="flat-butt flat-info-butt flat-info-grad-butt save-btn" (click)="reassignRole()">Save Changes</button>
    </div>
</form>
